import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

// Update free shipping progress bar dynamically
document.addEventListener('cart:updated', (event) => {
  const cart = event.detail?.cart;
  if (!cart) return;

  const threshold = 149900; // ₹1499 in paise
  const total = cart.total_price;
  const remaining = Math.max(0, Math.ceil((threshold - total) / 100));
  const progress = Math.min(100, Math.round((total / threshold) * 100));

  const bar = document.getElementById('cart-free-shipping-bar');
  if (!bar) return;

  const fill = bar.querySelector('.cart-free-shipping-bar__fill');
  const msg = bar.querySelector('.cart-free-shipping-bar__message');

  if (fill) fill.style.width = progress + '%';

  if (msg) {
    if (total >= threshold) {
      msg.classList.add('cart-free-shipping-bar__message--success');
      msg.innerHTML = "🎉 You've unlocked <strong>FREE shipping!</strong>";
    } else {
      msg.classList.remove('cart-free-shipping-bar__message--success');
      msg.innerHTML = `Add <strong>₹${remaining}</strong> more for <strong>FREE shipping!</strong>`;
    }
  }
});
